// Client for the lead intake endpoint (Azure Function: POST /api/intake).
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:7071';
export const INTAKE_URL = `${API_BASE}/api/intake`;

/**
 * Submit a lead. Resolves to one of:
 *   { ok: true }                          — saved (201)
 *   { ok: false, errors: string[] }       — validation failed (400); safe to show users
 * Throws on network failure or any unexpected status, so the caller can offer a fallback.
 */
export async function submitLead(lead) {
  const res = await fetch(INTAKE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(lead),
  });

  let body = null;
  try {
    body = await res.json();
  } catch {
    // non-JSON body — handled by the status checks below
  }

  if (res.status === 201) {
    return { ok: true };
  }
  if (res.status === 400 && body && Array.isArray(body.errors)) {
    return { ok: false, errors: body.errors };
  }
  throw new Error(`Unexpected response from intake endpoint: ${res.status}`);
}
